<template lang="pug">
  .sort-area
    .sort-area-inner
      span.count
        | {{ Number(total).toLocaleString() }}件
        | ヒット
      .sort-btn-wrapper
        a.open-search-button(@click="toggleSidebar") 検索条件
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        total: state => state.startingBusiness.pagination.totalCount,
      }),
    },
    methods: {
      toggleSidebar () {
        this.$emit('toggleSidebar')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessSortArea.vue